module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '9ycraoja',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
